import TeamCard from '../TeamCard';
import data from '../data';
import { Swiper, SwiperSlide } from 'swiper/react';
import TeamSeparatorIcon from 'ui/SVG/TeamSeparatorIcon';
import { swiperMobile } from './settings';

const SwiperMobile: React.FC = (props) => {
  return (
    <Swiper
      {...swiperMobile}
      // onInit={setSwiperControl}
      className="team__swiper team__swiper_main team__swiper_mobile"
    >
      {Object.values(data)
        .flat()
        .map((member) => (
          <SwiperSlide className="team__slide team__swiper_child" key={member.id}>
            <TeamSeparatorIcon className="team__separator" />
            <TeamCard {...member} />
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default SwiperMobile;
